import React, { Fragment, useRef, useState } from "react";
import _ from "lodash";

import RegisterFields from "./RegisterFields";
import orderFormFields from "./orderFormFields";

import { useSalePackageOptions } from "../Items/SalePackageItems/salePackageCatalog";

export const OrderForm = (props) => {
  const inputRef = useRef({});
  const [salePackage, setSalePackage] = useState("");
  const catalog = useSalePackageOptions(salePackage);

  const renderFields = () => {
    return _.map(
      orderFormFields,
      ({ label, name, type, options, required, disabled, description }) => {
        return (
          <RegisterFields
            key={name}
            name={name}
            label={label}
            type={type}
            value={
              name === "salePackage"
                ? salePackage
                : name === "receiptNo"
                ? props.saleOrderNumber
                : name === "warrantyEndDate"
                ? props.warrantyEnd
                  ? new Date(props.warrantyEnd).toLocaleDateString("fr-CA", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                  : ""
                : name === "warrantyStartDate"
                ? props.warrantyStart
                  ? new Date(props.warrantyStart).toLocaleDateString("fr-CA", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                  : ""
                : name === "receiptDate"
                ? props.warrantyStart
                  ? new Date(props.receiptDate).toLocaleDateString("fr-CA", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                  : ""
                : name === "warrantyPeriod"
                ? props.warrantyPeriod
                : inputRef.current[name]
            }
            fileNames={props.fileNames}
            options={name === "salePackage" ? catalog.options : options}
            required={required}
            onChange={(event) => {
              if (name === "salePackage") setSalePackage(event.target.value);
              props.onChange(name)(event);
            }}
            disabled={name === "salePackage" ? catalog.disabled : disabled}
            description={name === "salePackage" ? catalog.message : description}
          />
        );
      }
    );
  };

  return <Fragment>{renderFields()}</Fragment>;
};
